const FACEBOOK_CHAT_DRAFT_KEY = 'facebook-chat-draft-dirty';
const FACEBOOK_CHAT_DRAFT_MESSAGE =
	'You have an unsent message. Do you want to leave without sending it?';
export const FACEBOOK_CHAT_NAVIGATION_EVENT = 'facebook-chat-navigation';

export function setFacebookChatDraftDirty(isDirty: boolean) {
	if (isDirty) {
		sessionStorage.setItem(FACEBOOK_CHAT_DRAFT_KEY, 'true');
		return;
	}

	sessionStorage.removeItem(FACEBOOK_CHAT_DRAFT_KEY);
}

export function hasFacebookChatDraft() {
	return sessionStorage.getItem(FACEBOOK_CHAT_DRAFT_KEY) === 'true';
}

export function confirmDiscardFacebookChatDraft() {
	if (!hasFacebookChatDraft()) {
		return true;
	}

	const isConfirmed = window.confirm(FACEBOOK_CHAT_DRAFT_MESSAGE);

	if (isConfirmed) {
		setFacebookChatDraftDirty(false);
	}

	return isConfirmed;
}

export function notifyFacebookChatNavigation(route: string) {
	window.dispatchEvent(
		new CustomEvent(FACEBOOK_CHAT_NAVIGATION_EVENT, {
			detail: {
				route,
			},
		}),
	);
}

export { FACEBOOK_CHAT_DRAFT_MESSAGE };
